import React,{useEffect} from 'react'
import { FacebookProvider, Share } from 'react-facebook';
import { encryptUserInfo } from "../../../utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../utils/metricManagementUtil"
import './shared-facebook.scss'

const SharedFacebook = ({ href, children, zodiacSign=''}) => {
    const userInfoEncrypt= encryptUserInfo();
    return (
        <FacebookProvider appId="554978031914420">
            <Share href={href}>
                {({ handleClick, loading }) => (
                    <div onClick={handleClick} onClickCapture={()=>{pushDataLayerEvent({
                        event: "Interacciones - Horóscopo",
                        category: "magazin",
                        action: "click",
                        label: 'Facebook',
                        sub_category:'Horóscopo',
                        zodiac_sign: zodiacSign,
                        location: window.location.href,
                        user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
                        log_status: userInfoEncrypt.log_status,
                    })
                    pushDataLayerEvent({
                        event: "share",
                        method: "Facebook"
                    })}
                    }> 
                        {children}
                    </div>
                )}
            </Share>
        </FacebookProvider>
    )
}

export default SharedFacebook
